'use strict';

var cache = {};

module.exports = {
    initCache: function () {
        cache.$document = $(document);
    },
    updateGiftCertificateFormData: function () {
        this.initCache();

        cache.$document.on('updateAddToCartFormData', function (e, form) {
            var gcFormData = {
                gcRecipient: $('#giftcard-to').val(),
                gcSender: $('#giftcard-from').val(),
                gcRecipientEmail: $('#giftcard-email').val(),
                gcAmount: $('#giftcard-amount').val(),
                gcMessage: $('#giftcard-message').val()
            };
            $.extend(form, gcFormData);
        });
    }
};
